// ======================================================================
// File: src/modules/ppe/pages/orders/OrdersListPage.js
// ======================================================================

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import OrdersKpiBar from "../../components/orders/OrdersKpiBar";
import OrdersFilterBar from "../../components/orders/OrdersFilterBar";
import OrdersTable from "../../components/orders/OrdersTable";
import OrdersPagination from "../../components/orders/OrdersPagination";

import ppeOrderService from "../../services/ppeOrderService";

export default function OrdersListPage() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);

  const hasFilters = Object.keys(filters || {}).length > 0;

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await ppeOrderService.listOrders({
        page,
        page_size: pageSize,
        ...filters,
      });

      setRows(res.items || []);
      setTotal(res.total || 0);
    } finally {
      setLoading(false);
    }
  }, [page, pageSize, filters]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>
      {/* HEADER WITH CREATE BUTTON */}
      {/* PAGE HEADER */}
<div
  style={{
    background: "linear-gradient(90deg, #5f0cff, #7b2cff)",
    borderRadius: 14,
    padding: "16px 22px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  }}
>
  {/* LEFT */}
  <div>
    <div style={{ fontSize: 20, fontWeight: 700 }}>
      Production Orders
    </div>
    <div style={{ fontSize: 13, opacity: 0.9 }}>
      Create, track and manage production orders
    </div>
  </div>

  {/* RIGHT */}
  <button
    onClick={() => navigate("/ppe/orders/create")}
    style={{
      background: "#fff",
      color: "#5f0cff",
      border: "none",
      borderRadius: 8,
      padding: "8px 14px",
      fontWeight: 600,
      cursor: "pointer",
    }}
  >
    + Create Order
  </button>
</div>


      {/* KPI CARDS */}
      <OrdersKpiBar rows={rows} />

      {/* FILTERS */}
      <OrdersFilterBar
        filters={filters}
        onApply={(f) => {
          setPage(1);
          setFilters(f);
        }}
      />

      {/* TABLE */}
      <OrdersTable
        rows={rows}
        loading={loading}
        hasFilters={hasFilters}
      />

      {/* PAGINATION */}
      <OrdersPagination
        page={page}
        pageSize={pageSize}
        total={total}
        onPageChange={setPage}
        onPageSizeChange={(s) => {
          setPage(1);
          setPageSize(s);
        }}
      />
    </div>
  );
}
